export default __webpack_public_path__ + "4a51d44ee0a8d5c00183100501fd3be8.svg";